import { useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { useDispatch } from 'react-redux';
import { db } from '../firebase';
// import { updateBalanceInRedux } from '../store/slices/accountSlice'; // optional if using Redux

const useRealTimeBalance = (docId) => {
  useEffect(() => {
    if (!docId) return;

    const unsub = onSnapshot(
      doc(db, "trade_accounts", docId),
      (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.data();
          const newBalance = data.balance;
          console.log("🔁 Balance updated in Firestore:", newBalance);

          const user = JSON.parse(localStorage.getItem("user"));
          if (user && user.id === docId) {
            const updatedUser = { ...user, balance: newBalance };
            localStorage.setItem("user", JSON.stringify(updatedUser));
            console.log("✅ localStorage updated with new balance");
          }
        }
      },
      (error) => {
        console.error("🔥 Firestore listener error:", error);
      }
    );

    return () => unsub();
  }, [docId]);
};

export default useRealTimeBalance;
